/*
 *
 * Date: 2025
 * Description: Rules for form validation
 * Author: Philippe Leroux @SKITSC
 *
 */

//interfaces && types
import { i_user_rules } from "../interfaces/user.interface";

//Constants
import { lexiqueMessage } from "../utils/constant";
import { validateEmail, validateOptPassword, validatePassword, validateStr, validateUserType , validateEmpty } from "./validator"

const loginRules : i_user_rules[] = [
    { field: "password", validate: validatePassword, error: lexiqueMessage.password_error, },
    { field: "username", validate: validateEmpty, error: lexiqueMessage.empty_error },
    { field: "username", validate: validateStr, error: lexiqueMessage.str_error },
]

const userRules: i_user_rules[] = [
    { field: "username", validate: validateEmpty, error: lexiqueMessage.empty_error },
    { field: "username", validate: validateStr, error: lexiqueMessage.str_error },
    { field: "email", validate: validateEmail, error: lexiqueMessage.email_error, },
    { field: "password", validate: validatePassword, error: lexiqueMessage.password_error, },
    { field: "type" , validate: validateUserType, error: lexiqueMessage.user_type_error, },
];

const userUpdateRules: i_user_rules[] = [
    { field: "email", validate: validateEmail, error: lexiqueMessage.email_error, },
    { field: "password", validate: validateOptPassword, error: lexiqueMessage.password_error, },
    { field: "username", validate: validateEmpty, error: lexiqueMessage.empty_error },
    { field: "username", validate: validateStr, error: lexiqueMessage.str_error },
    { field: "type" , validate: validateUserType, error: lexiqueMessage.user_type_error, },
];
export { userRules , userUpdateRules , loginRules };